import Api from '@/services/Api'

// load, create, and delete class logins for the authenticated user

export default {
  get(teacherId) {
    return Api().get(`teachers/${teacherId}`);
  },
  invite(data) {
    return Api().post('teachers/invite', data);
  },
  put(teacherId, data) {
    return Api().put(`teachers/${teacherId}`, data);
  },
  delete(teacherId) {
    return Api().delete(`teachers/${teacherId}`);
  },
  updatePassword(teacherId, data) {
    return Api().put(`teachers/${teacherId}/changePassword`, data)
  }
}